import GenerativeAI from "./GenerativeAI";

export default GenerativeAI;